import type { TenantConfig } from '@/types/TenantConfig'

export const grpm: TenantConfig = {
  themeOptions: {
    dialog: {
      headerBackground: '#04b1ff',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
  },

  logo: {
    large: 'assets/grpm/static/grpm-logo.png',
    small: 'assets/grpm/static/grpm-mobile.png',
  },

  postCodeAsDiscountCode: {
    filter: 'US',
  },

  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tzq2gzh.css',
    },
  },
}
